var rich_content_viewer_default = {
  "fontElementMap": "ty1dc",
  "wrapper": "iD0Ov",
  "pluginContainerMobile": "hch4J",
  "viewer": "_5u-hj",
  "android": "UOsDH",
  "rootedTraversedContent": "_24jdN",
  "atomic": "VN7oh",
  "toolbar": "kTiWa",
  "block": "n9U3D"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
